import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../api/config';

// const url = `${PREFIX_URL}/v01/inbox/conversationAndLogs`;
const url = `${PREFIX_URL}/inbox-documents/:fileId/activities`;

type GetActivityLogsResponse = {
  data: {
    activityLogs: any[];
    conversations: any[];
  };
};

export const getActivityLogs = (fileId: number): Promise<GetActivityLogsResponse> => {
  return axios.get(generateRoutePath(url, { fileId }));
};

export const activityLogsKeys = {
  all: ['activityLogs'] as const,
  list: (fileId) => [INBOX_API_KEY, ...activityLogsKeys.all, fileId] as const,
};

type QueryFnType = typeof getActivityLogs;

type useActivityLogs = {
  fileId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useActivityLogs = ({ fileId, config }: useActivityLogs) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...activityLogsKeys.all, fileId],
    queryFn: () => getActivityLogs(fileId),
    staleTime: Infinity,
    ...config,
  });
};
